__turbopack_context__.v({
  "apBlock": "ComingSoonTaskCard-module-scss-module__B8vFTW__apBlock",
  "apIcon": "ComingSoonTaskCard-module-scss-module__B8vFTW__apIcon",
  "body": "ComingSoonTaskCard-module-scss-module__B8vFTW__body",
  "brand": "ComingSoonTaskCard-module-scss-module__B8vFTW__brand",
  "brandName": "ComingSoonTaskCard-module-scss-module__B8vFTW__brandName",
  "brandRow": "ComingSoonTaskCard-module-scss-module__B8vFTW__brandRow",
  "card": "ComingSoonTaskCard-module-scss-module__B8vFTW__card",
  "chip": "ComingSoonTaskCard-module-scss-module__B8vFTW__chip",
  "chipText": "ComingSoonTaskCard-module-scss-module__B8vFTW__chipText",
  "coverBlurred": "ComingSoonTaskCard-module-scss-module__B8vFTW__coverBlurred",
  "coverGradient": "ComingSoonTaskCard-module-scss-module__B8vFTW__coverGradient",
  "coverPlaceholder": "ComingSoonTaskCard-module-scss-module__B8vFTW__coverPlaceholder",
  "coverWrap": "ComingSoonTaskCard-module-scss-module__B8vFTW__coverWrap",
  "cta": "ComingSoonTaskCard-module-scss-module__B8vFTW__cta",
  "ctaAction": "ComingSoonTaskCard-module-scss-module__B8vFTW__ctaAction",
  "ctaCreate": "ComingSoonTaskCard-module-scss-module__B8vFTW__ctaCreate",
  "ctaIcon": "ComingSoonTaskCard-module-scss-module__B8vFTW__ctaIcon",
  "ctaIconAction": "ComingSoonTaskCard-module-scss-module__B8vFTW__ctaIconAction",
  "ctaIconCreate": "ComingSoonTaskCard-module-scss-module__B8vFTW__ctaIconCreate",
  "ctaIconShare": "ComingSoonTaskCard-module-scss-module__B8vFTW__ctaIconShare",
  "ctaIconWatch": "ComingSoonTaskCard-module-scss-module__B8vFTW__ctaIconWatch",
  "ctaShare": "ComingSoonTaskCard-module-scss-module__B8vFTW__ctaShare",
  "ctaWatch": "ComingSoonTaskCard-module-scss-module__B8vFTW__ctaWatch",
  "description": "ComingSoonTaskCard-module-scss-module__B8vFTW__description",
  "footer": "ComingSoonTaskCard-module-scss-module__B8vFTW__footer",
  "footerGlow": "ComingSoonTaskCard-module-scss-module__B8vFTW__footerGlow",
  "footerInner": "ComingSoonTaskCard-module-scss-module__B8vFTW__footerInner",
  "logo": "ComingSoonTaskCard-module-scss-module__B8vFTW__logo",
  "logoImg": "ComingSoonTaskCard-module-scss-module__B8vFTW__logoImg",
  "metaLeft": "ComingSoonTaskCard-module-scss-module__B8vFTW__metaLeft",
  "notifyBtn": "ComingSoonTaskCard-module-scss-module__B8vFTW__notifyBtn",
  "notifyIcon": "ComingSoonTaskCard-module-scss-module__B8vFTW__notifyIcon",
  "points": "ComingSoonTaskCard-module-scss-module__B8vFTW__points",
  "textBlurWrap": "ComingSoonTaskCard-module-scss-module__B8vFTW__textBlurWrap",
  "timeLeft": "ComingSoonTaskCard-module-scss-module__B8vFTW__timeLeft",
  "title": "ComingSoonTaskCard-module-scss-module__B8vFTW__title",
  "top": "ComingSoonTaskCard-module-scss-module__B8vFTW__top",
});
